import { classNames } from '@/utils';

import { SocialInboxMessageTranslateAction } from '@/components/pages/conversations/SocialInbox/components/SocialInboxChatView/SocialInboxMessageActions/SocialInboxMessageTranslateAction';

export const SocialInboxMessageActions = ({
    awsTranslation,
    toggleAwsTranslation,
    className
}: {
    awsTranslation: any;
    toggleAwsTranslation: () => void;
    className?: string;
}) => {
    return (
        <div className={classNames('flex items-center gap-2', className)}>
            <SocialInboxMessageTranslateAction
                awsTranslation={awsTranslation}
                toggleAwsTranslation={toggleAwsTranslation}
            />
        </div>
    );
};
